// Deal with divi things
(function($) {
	//Remove links from slider titles
	$('.et_pb_slide_title').each(function() {
		if ($(this).find('a').length) {
			$(this).html($(this).find('a').html());
		}
	});

	$(document).ready(function () {
		// Adding aria labels to slider navigation for WCAG
		$('.et-pb-slider-arrows .et-pb-arrow-prev').attr('aria-label', 'previous');
		$('.et-pb-slider-arrows .et-pb-arrow-next').attr('aria-label', 'next');
	});



	$('.et_pb_toggle_title').click(function(){
	var $toggle = $(this).closest('.et_pb_toggle');
	if (!$toggle.hasClass('et_pb_accordion_toggling')) {
	  var $accordion = $toggle.closest('.et_pb_accordion');
	  if ($toggle.hasClass('et_pb_toggle_open')) {
	    $accordion.addClass('et_pb_accordion_toggling');
	    $toggle.find('.et_pb_toggle_content').slideToggle(700, function() {
	      $toggle.removeClass('et_pb_toggle_open').addClass('et_pb_toggle_close');

	    });
	  }
	  setTimeout(function(){
	    $accordion.removeClass('et_pb_accordion_toggling');
	  }, 750);
	}
	});

	/**
	 * Close accordions by default
	 */
	$('.et_pb_accordion .et_pb_toggle_open')
		.addClass('et_pb_toggle_close')
		.removeClass('et_pb_toggle_open');

})(jQuery);
